import type { TenantConfig } from '@/types/TenantConfig'

export const chromasonic: TenantConfig = {
  logo: 'assets/chromasonic/static/logo.png',
  themeOptions: {
    dialog: {
      headerBorder: '1px solid black',
    },
    mobileFooter: {
      cartButtonIconColor: '#000000',
      cartButtonBorder: '1px solid #000000',
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  teaserImageSize: {
    height: 208,
  },
  componentOptions: {
    checkoutRoute: {
      stripeWallets: true,
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/chromasonic/static/fonts2.css',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        title: '<span>Thank you</span>We look forward to your presence.',
      },
    },
  },
}
